/* eslint-disable @typescript-eslint/ban-types */
import React from 'react'
import { NO_OVERVIEW_DATA } from '../constants'
import NoOverviewComponentData from './NoOverviewComponentData'

export type NoDataGuardProps<T extends object> = {
  data: T | typeof NO_OVERVIEW_DATA
  component: React.ComponentType<T>
  title: string
}

export function NoDataGuard<T extends object>({
  data, component: Component, title,
}: NoDataGuardProps<T>): JSX.Element {
  if (data === NO_OVERVIEW_DATA) {
    return <NoOverviewComponentData title={title} />
  }

  return <Component {...data} />
}
